// Item delivery types — the "close the loop" data model.
// A delivery record is created when a prioritized item is shipped, partially
// delivered, or cancelled. It captures what actually happened versus what was
// predicted at scoring time, building calibration data over time.

export type DeliveryType = 'shipped' | 'partial' | 'cancelled';

export const DELIVERY_TYPE_LABELS: Record<DeliveryType, string> = {
  shipped: 'Shipped',
  partial: 'Partially delivered',
  cancelled: 'Cancelled / dropped',
};

export const DELIVERY_TYPE_DESCRIPTIONS: Record<DeliveryType, string> = {
  shipped: 'The full scope was delivered as expected.',
  partial: 'Something shipped, but scope or impact was reduced.',
  cancelled: 'Work stopped — deprioritized, infeasible, or made redundant.',
};

// A single named metric with a predicted and actual value.
export interface MetricComparison {
  key: string;
  label: string;
  predicted: number | null;
  actual: number | null;
  unit?: string;
}

// Snapshot of the priority framework scores at the time the item was ranked.
export interface PredictedScores {
  toolName: string;         // e.g. 'rice-scoring', 'wsjf'
  numericScore?: number;
  rank?: number;
  inputs?: Record<string, number | string>;  // raw scoring inputs
  snapshotId?: string;
}

export interface ItemDelivery {
  id: string;
  itemId: string;
  workspaceId: string;
  deliveredAt: string;
  deliveryType: DeliveryType;
  predictedScores: PredictedScores | null;
  actualMetrics: Record<string, number | string> | null;
  scoreAccuracy: number | null;   // 0–1
  notes: string | null;
  lessonsLearned: string | null;
  createdBy: string | null;
  createdAt: string;
}

// Summary stats for the calibration dashboard — one definition, shared with the
// public API: supabase/functions/_shared/calibrationCore.ts.
export type { CalibrationStats } from '../../supabase/functions/_shared/calibrationCore.ts';
